import * as _ from 'underscore'

import { Enums } from "../common/enums"
import { OpDescr } from '../core'

import { IOpChangeState } from "../util/interfaces"


export class OpTransmissionDriverType implements IOpChangeState {

    //#region Properties

    public idTransmissionDriverType: number
    public name: string
    public idDescr: number

    //#endregion


    //#region Navigation properties

    public set descr(value: OpDescr) {
        this._descr = value

        if (value != null) {
            this.idDescr = value.idDescr
        }
    }
    public get descr(): OpDescr { return this._descr }

    private _descr: OpDescr

    //#endregion

    //#region Custom properties

    public opState: Enums.OpChangeState

    //#endregion


    //#region Ctor

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    //#endregion    

    public toString(): string {
        return this.name
    }

    //#region IJsonSerializer Implementation

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj != null) {
            this.idTransmissionDriverType = opObj.ID_TRANSMISSION_DRIVER_TYPE
            this.name = opObj.NAME
            this.idDescr = opObj.ID_DESCR

            if (opObj._Descr != null) {
                this._descr = new OpDescr(opObj._Descr)
            }

            this.opState = opObj.OpState
        }
    }

    public toJSON(compressed: boolean = false): any {
        return {
            ID_TRANSMISSION_DRIVER_TYPE: this.idTransmissionDriverType,
            NAME: this.name,
            ID_DESCR: this.idDescr,
            OpState: this.opState,

            _Descr: this._descr != null ? this._descr.toJSON() : null
        }
    }

    //#endregion

    //#region ICopyable Implementation

    public clone(includeNavigationProperties: boolean = false, includeCustomProperties: boolean = false, includeDataList: boolean = false, includeDynamicValues: boolean = false): OpTransmissionDriverType {
        const driverType: OpTransmissionDriverType = new OpTransmissionDriverType(null)

        driverType.copy(this, includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)

        return driverType
    }

    public copy(source: OpTransmissionDriverType, includeNavigationProperties: boolean = false, includeCustomProperties: boolean = false, includeDataList: boolean = false, includeDynamicValues: boolean = false): void {
        if (source == null) {
            return
        }

        if (includeNavigationProperties) {
            if (source.descr != null) {
                this.descr = OpDescr.restore(source.descr)
            }
        }

        if (includeCustomProperties) {

        }

        if (includeDataList) {
            //no data list
        }

        if (includeDynamicValues) {
            //no dynamic values
        }

        this.idTransmissionDriverType = source.idTransmissionDriverType
        this.name = source.name
        this.idDescr = source.idDescr

        this.opState = source.opState
    }

    //#endregion

}